import { useQuery } from "@tanstack/react-query";
import { getStockWarningsApi } from "../api/stockWarningsApi";
import type { StockLocationId, StoreId } from "@KassaroAB/shared/types/ids";

export const useGetStockWarningsQuery = (
  storeId: StoreId | null,
  stockLocationId: StockLocationId | null,
) => {
  return useQuery({
    queryKey: ["stores", storeId, "stockWarnings", stockLocationId],
    queryFn: () => getStockWarningsApi(storeId!, stockLocationId),
    enabled: !!storeId,
  });
};
